import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

const TOKEN_KEY = "gs_token";
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
  }
}
// Restore token on load
const _saved = typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
if (_saved) api.defaults.headers.common.Authorization = `Bearer ${_saved}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const GBP = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n || 0);

export const PAYMENT_LABELS = {
  unpaid: "Unpaid",
  deposit_paid: "Deposit paid",
  part_paid: "Part paid",
  paid_in_full: "Paid in full",
  sponsored: "Sponsored / funded",
  payment_plan_active: "Payment plan active",
  overdue: "Overdue",
  refunded: "Refunded",
  comped: "Free access",
};

export const STATUS_LABELS = {
  applied: "Applied",
  approved: "Approved",
  waitlisted: "Waitlisted",
  rejected: "Rejected",
  enrolled: "Enrolled",
  completed: "Completed",
};
